module.exports = __webpack_public_path__ + "static/media/iconCopy.148f8221.svg";